import NormalRates from './NormalRates';

export default NormalRates;
